import map from "lodash/fp/map";
import assign from "lodash/fp/assign";
import flow from "lodash/fp/flow";
import cloneDeep from "lodash/fp/cloneDeep";
import { mapKeyValue } from "../../core/transforms";
class CitiesPageTransform {
  constructor(Lists, Events) {
    "ngInject";
    this.Lists = Lists.all;
    this.events = Events;
    this.selectCityLanguage = this.events.getSelectCityLanguageEvent();
    this.events.on(this.selectCityLanguage, (field) => {
      const languages = cloneDeep(this.Lists.availableCityLanguages);
      this.addOptions.fields[1].languages = languages.filter((lang) => {
        if (field.value.includes(lang.code)) {
          lang.isRequired = true;
          return true;
        }
        return false;
      });
    });
    // NOTE: name is used for (user roles)
    this.item = {
      title: "City",
      state: "city",
      name: "city",
    };

    this.fields = [
      { title: "Name", name: "name", isSortable: true },
      { title: "Currency", name: "currency" },
    ];

    this.filters = [
      {
        name: "search",
        title: "Search",
        icon: "search",
        isSearch: true,
        resource: "City",
        state: "city",
        size: 25,
      },
    ];

    this.addOptions = {
      title: "Add New City",
      icon: "add",
      fields: [
        {
          name: "languages",
          title: "City Supported Languages",
          isCityLanguages: true,
          onChange: this.selectCityLanguage,
        },
        {
          name: "name",
          title: "Name",
          type: "text",
          isRequired: true,
          isI18nText: true,
          languages: this.Lists.requiredCityLanguages,
        },
        {
          name: "country",
          title: "Country",
          list: "countries",
          isRequired: true,
        },
        {
          name: "currency",
          title: "Currency",
          type: "text",
          isText: true,
          isRequired: true,
        },
        {
          name: "timezone",
          title: "Timezone",
          type: "number",
          isTimezone: true,
          isText: true,
          isRequired: true,
        },
        {
          name: "hotlines",
          title: "Hotlines",
          isItemsList: true,
          items: [],
          type: "number",
          formatter: mapKeyValue,
          isRequired: false,
        },
        {
          name: "emails",
          title: "Email",
          isItemsList: true,
          items: [],
          type: "email",
          formatter: mapKeyValue,
          isRequired: false,
        },
        {
          name: "numbers",
          title: "Numbers",
          isItemsList: true,
          items: [],
          type: "number",
          formatter: mapKeyValue,
          isRequired: false,
        },
      ],
    };
  }

  justify(data) {
    const getSource = (item) => assign({ _id: item._id }, item._source);
    const mapLocalizedName = (item) => {
      if (item.name_i18n) {
        item.name = item.name_i18n.en;
      }
      return item;
    };
    return map(flow([getSource, mapLocalizedName]))(data);
  }
}

export default CitiesPageTransform;



// WEBPACK FOOTER //
// ./src/pages/cities/cities.transforms.js